/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GridColDef,
  GridRenderCellParams,
  GridValueFormatterParams
} from '@mui/x-data-grid-premium';
import { baseCell, currencyCell } from 'components/cells';
import {
  filterOperators,
  dateFilterOperators,
  numberFilterOperators,
  singleSelectFilterOperators
} from 'components/enhanced';
import { currencyFormatter } from 'components/helpers/currency-formatter';
import { EquipmentInvoiceLineType } from 'features/inventory/invoices/constants';
import { useTranslation } from 'react-i18next';

export function EquipmentInvoiceLinesColumns(): GridColDef[] {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    {
      field: 'contract_code',
      headerName: t(`global.contract`),
      width: 200,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'supplier',
      headerName: t(`global.supplier`),
      width: 200,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'notes',
      headerName: t(`global.notes`),
      width: 200,
      editable: true,
      renderCell: baseCell
    },
    {
      field: 'type',
      headerName: t(`global.type`),
      width: 150,
      type: 'singleSelect',
      filterOperators: singleSelectFilterOperators,
      valueOptions: Object.entries(EquipmentInvoiceLineType).map(([key, value]) => {
        return { value, label: t(`pages.equipment-invoices.detail.modes.${value}`) };
      }),
      renderCell: (params: GridRenderCellParams<any, any>) =>
        t(`pages.equipment-invoices.detail.modes.${params.value}`)
    },
    {
      field: 'equipment',
      headerName: t(`global.equipment-or-service`),
      width: 200,
      filterOperators,
      renderCell: baseCell
      // valueFormatter: ({ value }) => {
      //   const values = value.map((value) => value.code);
      //   return values.join(', ');
      // },
      // renderCell: (params: GridRenderCellParams) => {
      //   const value = params.value.map((value) => value.code);
      //   return <DataGridCell content={value ? value.join(',') : ''} />;
      // }
    },
    {
      field: 'description',
      headerName: t(`global.description`),
      width: 200,
      renderCell: baseCell
    },
    {
      field: 'serial_number',
      headerName: t(`entities.equipment.serial_number`),
      width: 200,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'period_ref',
      headerName: t(`global.date`),
      width: 200,
      filterOperators: dateFilterOperators,
      renderCell: baseCell,
      editable: false
    }
  ];

  ['amount', 'expected_amount'].forEach((colName) => {
    columns.push({
      field: colName,
      headerName: t(`entities.ddt.${colName}`),
      filterOperators: numberFilterOperators,
      editable: true,
      type: 'number',
      width: 150,
      valueFormatter: (params: GridValueFormatterParams) => {
        return currencyFormatter(params.value);
      },
      renderCell: currencyCell
    });
  });

  return columns;
}
